import type { GiftPassStatus } from '../../api/gift-passes';
import { DotPill } from '../dashboards/primitives/DotPill';

import { GIFT_PASS_STATUS_LABEL } from './gift-passes-model';

const TONE: Record<GiftPassStatus, { color: string; background: string }> = {
  ISSUED: { color: 'var(--nb-muted)', background: 'var(--nb-surface-2)' },
  SENT: { color: 'var(--nb-info)', background: 'var(--nb-info-soft)' },
  REDEEMED: { color: 'var(--nb-primary-2)', background: 'var(--nb-primary-soft)' },
  VOIDED: { color: 'var(--nb-subtle)', background: 'var(--nb-surface)' },
  EXPIRED: { color: 'var(--nb-warn)', background: 'var(--nb-warn-soft)' },
};

export function GiftPassStatusPill({ status }: { status: GiftPassStatus }) {
  return <DotPill label={GIFT_PASS_STATUS_LABEL[status]} {...TONE[status]} />;
}
